import {NewsBody} from "./news.body";
import {InterfaceNews, InterfaceNewsItem} from "../../interface/press-center/interface.news";
import {NewsPageService} from "./service/news.page.service";
import {NewsStore} from "../../store/news.store";
import {NewsPage} from "./news.page";

export class NewsSearch {
    private searchBtn: HTMLElement | null;
    private search: HTMLInputElement | null;

    constructor(
        private container: HTMLElement,
        private loader: HTMLElement | null,
        private newsStore: NewsStore,
        private pressCenterNews: HTMLElement[]
    ) {
        this.searchBtn = container.querySelector('[data-search-btn]');
        this.search = container.querySelector('[data-search]');
    }

    public initialize(): void {
        if (this.searchBtn) {
            this.searchBtn.addEventListener('submit', (e: SubmitEvent) => {
                e.preventDefault();
                history.pushState(null, '', location.pathname);
                new NewsPageService(this.loader).getNewsBySearch(this.search?.value ?? null)
                    .then((data: InterfaceNews | null) => {
                        const dataFeaturedNews: InterfaceNewsItem[] = this.newsStore.getFeaturedNews();
                        if (data && dataFeaturedNews) {
                            new NewsPage(this.newsStore, this.loader, this.pressCenterNews, data.TotalCount)
                                .initialize();
                            this.pressCenterNews.forEach((item: HTMLElement) => new NewsBody(
                                item,
                                data.News,
                                data.TotalCount,
                                dataFeaturedNews,
                                this.newsStore,
                                this.loader,
                                this.pressCenterNews
                            ).initialize());
                        }
                    });
            })
        }
    }
}
